var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_936_1084)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_936_1084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8539 5.4984C22.4778 4.27267 14.9498 4.27267 7.57358 5.4984C3.35545 6.38168 0.723633 9.10364 0.723633 12.6548V25.2732C0.723633 28.8784 3.35545 31.5643 7.64568 32.4836C11.3149 33.1014 15.0289 33.4149 18.7498 33.421C22.4821 33.4201 26.208 33.1126 29.89 32.5016C34.0721 31.7085 36.776 28.8964 36.776 25.2912V12.6728C36.776 9.08561 34.0721 6.27353 29.8539 5.4984ZM24.6263 19.8112L15.6133 25.2191C15.4723 25.3049 15.3096 25.3487 15.1446 25.3453C14.9881 25.344 14.8339 25.307 14.6939 25.2371C14.5522 25.1511 14.4358 25.0289 14.3566 24.8832C14.2775 24.7376 14.2383 24.5736 14.2433 24.4079V13.5922C14.2446 13.4325 14.2867 13.2759 14.3656 13.1371C14.4445 12.9982 14.5575 12.8819 14.6939 12.799C14.8353 12.7233 14.9932 12.6836 15.1536 12.6836C15.314 12.6836 15.4719 12.7233 15.6133 12.799L24.6263 18.2069C24.7567 18.2899 24.8639 18.4045 24.9382 18.54C25.0125 18.6755 25.0514 18.8275 25.0514 18.982C25.0514 19.1365 25.0125 19.2885 24.9382 19.424C24.8639 19.5595 24.7567 19.674 24.6263 19.7571V19.8112Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_936_1084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.0524,
    height: 36.0524,
    fill: "white",
    transform: "translate(0.723633 0.973633)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_936_1084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.0524,
    height: 28.8419,
    fill: "white",
    transform: "translate(0.723633 4.5791)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.71d62c9ed1fe6d66321dc7d1ae3b4502.svg";
export { ForwardRef as ReactComponent };